import { render, staticRenderFns } from "./courseContentSetting.vue?vue&type=template&id=312579f0&scoped=true&"
import script from "./courseContentSetting.vue?vue&type=script&lang=js&"
export * from "./courseContentSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseContentSetting.vue?vue&type=style&index=0&id=312579f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312579f0",
  null
  
)

export default component.exports